import React from 'react';
import { projects } from '../data/projects';
import { FeaturedProject } from './FeaturedProject';
import { ProjectCard } from './ProjectCard';
import { SectionHeading } from './SectionHeading';
export function Projects() {
  return <section id="proyectos" className="border-b border-hairline py-24 lg:py-32" data-id="element-214" data-mp="um8bfwpizu30">
      <div className="mx-auto max-w-6xl px-6" data-id="element-215" data-mp="psxcsiuvajm6">
        <SectionHeading index="04 — Proyectos" title="El ecosistema SolarisPKN" description="Cuatro proyectos que se apoyan entre sí: uno los contiene, uno controla hardware, uno mide y uno produce contenido. Todos abiertos y documentados en inglés y español." data-id="element-216" data-mp="ps443ccclk1e" />

        <div className="mt-14" data-id="element-217" data-mp="1dh6ub8l1sl7i">
          <FeaturedProject data-id="element-218" data-mp="18k6omys41kgx" />
        </div>

        <div className="mt-8 grid gap-8 lg:grid-cols-2" data-id="element-219" data-mp="18l7yx11ay2xl">
          {projects.map(project => <ProjectCard key={project.id} project={project} data-id="element-220" data-mp="3fb63noem0shk" />)}
        </div>
      </div>
    </section>;
}